import { useEffect, useState } from 'react'
import { UseOnClickOutsideInterface } from '../interfaces/UseOnClickOutside.types'

// This code reference from https://www.npmjs.com/package/react-onclickoutside
const listenForOutsideClicks = ({
  isListening,
  setIsListening,
  menuRef,
  setIsOpen,
}: UseOnClickOutsideInterface) => {
  return () => {
    if (isListening) return
    if (!menuRef.current) return

    setIsListening(true)

    const eventToListen = ['mousedown']

    // Will The test Soon
    /* istanbul ignore next */
    eventToListen.forEach(() => {
      document.addEventListener('mousedown', (event) => {
        const target = event.target as HTMLDivElement

        if (menuRef.current) {
          event.stopPropagation()
          if (menuRef.current.contains(target)) return
          setIsOpen(false)
        }
      })
    })
  }
}

const useOnClickOutside = (menuRef, handleClose) => {
  const [isListening, setIsListening] = useState(false)

  useEffect(
    listenForOutsideClicks({ isListening, setIsListening, menuRef, setIsOpen: handleClose }),
  )
}

export default useOnClickOutside
